import { DateKey } from "../common/DateKey"

export interface ServiceAvailability {
  [id: DateKey]: boolean
}

export enum BookingDayStatus {
  AVAILABLE = "AVAILABLE",
  // Only one (weighted) slot is left on the day
  LAST_SLOT = "LAST_SLOT",
  FULL = "FULL",
  // Closed, or blocked by the same-day booking rules
  UNAVAILABLE = "UNAVAILABLE",
}

export type BookingDayStatuses = Record<DateKey, BookingDayStatus>

export const isBookableDayStatus = (status: BookingDayStatus): boolean =>
  status === BookingDayStatus.AVAILABLE || status === BookingDayStatus.LAST_SLOT

/** The earliest day that can be booked, or null when no day can. */
export const findFirstBookableDate = (
  dayStatuses: BookingDayStatuses,
): Date | null => {
  // YYYY-MM-DD keys sort chronologically
  const [firstDateKey] = Object.entries(dayStatuses)
    .filter(([, status]) => isBookableDayStatus(status))
    .map(([dateKey]) => dateKey)
    .sort()
  // Midday, so the date stays the same in every time zone we run in
  return firstDateKey === undefined
    ? null
    : new Date(`${firstDateKey}T12:00:00.000Z`)
}

export const toServiceAvailability = (
  dayStatuses: BookingDayStatuses,
): ServiceAvailability =>
  Object.fromEntries(
    Object.entries(dayStatuses).map(([dateKey, status]) => [
      dateKey,
      isBookableDayStatus(status),
    ]),
  )
